<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title">The Trembling Hills</p>
<p class="ORIM-Author-Name">Phyllis A. Whitney</p>
<p class="ORIM-Author-Name"><img alt="image" class="svg" src="image/fig_01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Whitney_TremblingHills_2P-1.vue?4de73b68